import React from 'react';
import { StepStatus } from './StepDefinition';

type UseAutoAdvanceArgs = {
	status: StepStatus;
	isCompleted: boolean;
	onAutoAdvance: () => void;
};

// Realmente en nuestros flujos solo podemos autoavanzar si estamos en estado nuevo, o el step
// marca el flag de autoavanzar (en estado review no dejamos avanzar). 
// Y por supuesto siempre y cuando se cumpla la condición isCompleted
export function useAutoAdvance({
	status,
	isCompleted,
	onAutoAdvance,
}: UseAutoAdvanceArgs) {

	const [autoAdvanceEnabled, setAutoAdvanceEnabled] = React.useState(false);

	// Se arma al entrar al step como 'pending', permito que se autocomplete
	// si el estado de la composición ya lo permite
	React.useEffect(() => {
		if (status === 'pending')
			setAutoAdvanceEnabled(true);
	}, [status]);

	// Si está armado y ya está completo, dispara y se desarma
	React.useEffect(() => {

		if (!autoAdvanceEnabled)
			return;

		if (!isCompleted)
			return;

		// Si estoy revisando, no permito navegar al siguiente estado.
		if (status === 'review')
			return;

		setAutoAdvanceEnabled(false);
		onAutoAdvance();
	}, [autoAdvanceEnabled, isCompleted, onAutoAdvance, status]);

	// API explícita para el step
	const enableAutoAdvance = React.useCallback(() => {
		setAutoAdvanceEnabled(true);
	}, []);


	const disableAutoAdvance = React.useCallback(() => {
		setAutoAdvanceEnabled(false);
	}, []);

	return { enableAutoAdvance, disableAutoAdvance };
}